/**
 * Styled Components - Created by jorge on 01/08/18.
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'

export const Container = styled.div`
  background-color: #fff;
`
export const BoxHeaderRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 34px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 34px;
  }
`

interface BoxProps {
  checked?: boolean
  secondary?: boolean
  fromModal?: boolean
}

export const BoxHeader = styled.div`
  background: ${({ checked }: BoxProps) =>
    checked ? '#232323' : WHITE};
  border-radius: 2px;
  color: ${({ checked }: BoxProps) =>
    checked ? WHITE : '#5f6062'};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 23px;
  margin: 0px 12.5px 10px;
  padding: 14px 0px;
  text-align: center;
  width: 100px;
  cursor: pointer;
  box-shadow: 1px 2px 4px 0px #dedede;
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 12px;
    margin: 0px 2px;
    width: 82px;
  }
`

export const TableList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  padding: ${({ fromModal }: BoxProps) => fromModal ? '0px' : '0px 48px'};
  @media (min-width: 320px) and (max-width: 846px) {
    padding: 0px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizingChart/styledComponents.tsx